import React, { useEffect, useState } from "react";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { InputNoticeList } from "./input-notice-list";
import type { InputProps } from "./types";
import apiClient from "../../../../application/apis/tenant-management/tenant-management-client";
import { reportUnexpectedError } from "../../../../error-reporter";
import { toast } from "react-toastify";
import { Group } from "../../../../application/domain/group/group";

const notices = [
  "手続きが属する管理グループです。管理グループの変更は特権管理者のみ編集可能です",
];

type Props = Omit<InputProps, "onChange"> & { groupId: string };

export const ProcedureDetailJurisdictionGroupNameInput: React.FC<Props> = ({
  disabled = false,
  groupId,
}) => {
  const [currentGroup, setCurrentGroup] = useState<Group>();
  const fetchCurrentGroup = React.useCallback(async () => {
    try {
      const { data: group } = await apiClient.fetchGroupById(groupId);
      setCurrentGroup(group);
    } catch (e) {
      reportUnexpectedError(e);
      toast.error("グループの取得に失敗しました。" + e.message);
    }
  }, [groupId, setCurrentGroup]);

  useEffect(() => {
    fetchCurrentGroup();
  }, [fetchCurrentGroup]);

  return (
    <div className="field mb-6">
      <FormFieldLabel label="管理グループ" />
      <InputNoticeList notices={notices} />
      <div className="control">
        <input
          className="input"
          value={currentGroup?.name}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
